<template>
  <article class="hc-statistic">
    <div class="hc-statistic__top">
      <span class="hc-statistic__icon"><i :class="icon" aria-hidden="true"></i></span>
      <slot name="meta"><HcBadge v-if="badge" :variant="badgeVariant">{{ badge }}</HcBadge></slot>
    </div>
    <span class="hc-statistic__value">{{ value }}</span>
    <span class="hc-statistic__label">{{ label }}</span>
    <div v-if="trend || $slots.trend" class="hc-statistic__trend">
      <slot name="trend"><strong>{{ trend }}</strong><span>{{ trendLabel }}</span></slot>
    </div>
  </article>
</template>

<script>
import HcBadge from "./HcBadge.vue";

export default {
  name: "HcStatistic",
  components: { HcBadge },
  props: {
    label: { type: String, default: "" },
    value: { type: [String, Number], default: "0" },
    icon: { type: String, default: "fas fa-chart-line" },
    badge: { type: String, default: "" },
    badgeVariant: { type: String, default: "success" },
    trend: { type: String, default: "" },
    trendLabel: { type: String, default: "" },
  },
};
</script>
